/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyExpenses = {
    type: 'array',
    contains: {
        type: 'CompanyExpense',
    },
};